import apiClient from "@/api/axios";

/**
 * Obtener la información del dashboard
 * @returns {Promise<any>} Información del dashboard
 */
export const drivers = async (page, limit) => {
    try {
        const response = await apiClient.get('/admin/drivers',{
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener el dashboard:', error);
        throw error;
    }
};

/**
 * Obtener los logs del sistema
 * @returns {Promise<any>}
 */
export const getLogsService = async () => {
    try {
        const response = await apiClient.get('/admin/logs');
        return response.data;
    } catch (error) {
        console.error('Error al obtener los logs:', error);
        throw error;
    }
};

/**
 * Obtener los logs del sistema
 * @returns {Promise<any>}
 */
export const cars = async (page, limit) => {
    try {
        const response = await apiClient.get('/admin/cars',{
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener los cars:', error);
        throw error;
    }
}

/**
 * Obtener los drivers sin carro asignado
 * @returns {Promise<any>}
 */
export const driversUnassigned = async (page, limit) => {
    try {
        const response = await apiClient.get('/admin/drivers/unassigned',{
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener los drivers:', error);
        throw error;
    }
}

/**
 * Asignar un conductor a un carro
 * @param carId
 * @param driverId
 * @returns {Promise<any>}
 */
export const assignDriver = async (carId, driverId) => {
    try {
        const response = await apiClient.put(`/admin/cars/${carId}/assign-driver`, { driverId });
        return response.data;
    } catch (error) {
        console.error('Error al asignar el conductor:', error);
        throw error;
    }
}

/**
 * Desasignar un conductor de un carro
 * @param {String} carId ID del carro
 * @returns {Promise<any>}
 */
export const unAssignDriver = async (carId) => {
    try {
        const response = await apiClient.put(`/admin/cars/${carId}/unassign-driver`);
        return response.data;
    } catch (error) {
        console.error('Error al desasignar el conductor:', error);
        throw error;
    }
}